import { render } from "./MyCoin.vue?vue&type=template&id=099720a8&scoped=true"
import script from "./MyCoin.vue?vue&type=script&lang=js"
export * from "./MyCoin.vue?vue&type=script&lang=js"

import "./MyCoin.vue?vue&type=style&index=0&id=099720a8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099720a8"]])

export default __exports__